import React from 'react';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Skeleton, Chip } from '@mui/material';
import { formatDate } from '../../../utils/formatters/date';

export default function MedsActiveTable({ items = [], loading }) {
  if (loading) return <Skeleton variant="rounded" height={260} />;
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400, overflow: 'auto' }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ '& th': { backgroundColor: '#607d8b', color: '#fff', fontWeight: 'bold' } }}>
            <TableCell>Medication</TableCell>
            <TableCell>Strength</TableCell>
            <TableCell>Form</TableCell>
            <TableCell>Route</TableCell>
            <TableCell>Frequency</TableCell>
            <TableCell>Doctor</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((m, idx) => (
            <TableRow
              key={m.id || idx}
              sx={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f5f5f5', '&:hover': { backgroundColor: '#e3f2fd' } }}
            >
              <TableCell sx={{ fontWeight: 600 }}>{m.name}</TableCell>
              <TableCell>{m.drugStrength || m.dose || '—'}</TableCell>
              <TableCell>{m.doseForm || '—'}</TableCell>
              <TableCell>{m.route || '—'}</TableCell>
              <TableCell>{m.frequency || '—'}</TableCell>
              <TableCell>{m.doctor || '—'}</TableCell>
              <TableCell>{formatDate(m.startDate)}</TableCell>
              <TableCell>
                {m.status ? (
                  <Chip
                    size="small"
                    label={m.status}
                    color={m.status.toLowerCase().includes('current') ? 'success' : 'default'}
                    variant="outlined"
                    sx={{ borderRadius: 2, fontSize: '0.7rem' }}
                  />
                ) : '—'}
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && (
            <TableRow>
              <TableCell colSpan={8} align="center">No active medications</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
